import { Pipe, PipeTransform } from '@angular/core';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { Specialite } from 'src/app/shared/models/specialite';

@Pipe({
	name: 'filterMissionPlaceBySpecialties'
})
export class FilterMissionPlaceBySpecialtiesPipe implements PipeTransform {
	transform(
		missionPlaces: MissionPlace[],
		specialties: Specialite[]
	): MissionPlace[] {
		if (
			missionPlaces === null ||
			specialties === null ||
			specialties === [] ||
			specialties.length === 0
		) {
			return missionPlaces;
		}

		return missionPlaces.filter((missionPlace) => {
			return missionPlace.specialties.some((spe) =>
				specialties
					.map((spec) => spec.name)
					.some((specStr) => specStr.includes(spe.name))
			);
		});
	}
}
